app.service('basketServiceReminder', function (console, loading, modal, html, pageConfig, basketAnalytics,
	updateExcludedServices, updateServicePrices, broker, front, ajaxOrder) {
	let $self, $form, $actionInput, $serviceInput, $servicesToAdd, $servicesQuantityOnModal, $servicesOnModal, $summary, $addServicesButton;
	let config, modalContent;

	function open() {
		if (!modalContent) {
			modalContent = $('#service-to-add-reminder-old').html();
			$('#service-to-add-reminder-old').remove();
			modal.generate({
				id: 'modal-service-to-add-reminder',
				content: modalContent,
				callbackOpen: function () {
					setElements();
					setEvents();
				}
			});
		} else {
			modal.open('modal-service-to-add-reminder');
		}
	}
	function destroyModalServiceReminder() {
		modalContent = false;
		modal.destroy('service-to-add-reminder');
	}
	function submit() {
		loading.start();
		modal.close(false);
		const config = pageConfig.getData('order');
		if (testAB.getVar('ajax-order2') === 'B' && front.getParam('ajaxOrder')) {
			if(!config.isUserLogged && config.keycloakEnabled) {
				// w tym przypadku wiemy że napewno nie jesteśmy zalogowani, więc nie wysyłamy formularza, tylko przekierowujemy na logowanie w keycloak
				console.log('KOLEJNA STRONA TO KEYCLOAK, PRZEKIEROWANIE NA LOGOWANIE');
			} else {
				ajaxOrder.setForm($form);
			}
		}
		$form.submit();
	}
	function logToCartEvent(servicesEventArray) {
		if (servicesEventArray.length) {
			servicesEventArray.forEach(function (service) {
				basketAnalytics.addService({
					productPlu: service.productPlu,
					servicePlu: service.servicePlu,
					details: 'services_box',
					quantity: service.quantity / 1,
				});
			})
		}
	}
	function addServices() {
		var checkedServices = [];
		var logEventServicesData = []
		$servicesOnModal.filter(':checked').each(function () {
			const product = $(this).data('product');
			const service = $(this).data('service');
			const quantity = $(this).data('quantity');
			toggleService(product, service);
			logEventServicesData.push({
				productPlu: $(this).data('product-plu'),
				servicePlu: $(this).data('service-plu'),
				quantity: quantity
			})
			checkedServices.push(product + '|' + service + '|' + quantity);
		});
		if (checkedServices.length) {
			$actionInput.val('ADD_SELECTED_SERVICES');
			$serviceInput.val(checkedServices.join(','));
			logToCartEvent(logEventServicesData);
			submit();
		} else {
			skip();
		}
	}
	function skip() {
		$actionInput.val('REMOVE_SELECTED_SERVICES');
		submit();
	}

	function setButtonStatus() {
		if ($servicesOnModal.filter(':checked').length) {
			$addServicesButton.prop('disabled', false);
		} else {
			$addServicesButton.prop('disabled', true);
		}
	}

	function toggleService(product, service) {
		var $service = $servicesToAdd.filter('[data-product=' + product + ']').filter('[data-service=' + service + ']');
		$service.prop('checked', !$service.prop('checked'));
	}
	function changeQuantity(value, productId, serviceId) {
		let $service = $servicesOnModal.filter('[data-product=' + productId / 1 + ']').filter('[data-service=' + serviceId + ']');
		if ($service.length) {
			$service.attr('data-quantity', value);
		} else {
			console.log('Brak usługi do zmiany')
		}
	}
	function setElements() {
		config = pageConfig.getData('order');
		$self = $('#modal-service-to-add-reminder');
		$form = $('form', $self);
		$form.attr('action', config.deliveryMode ? '/cart-delivery.bhtml' : '/cart.bhtml');
		$summary = $('.js-services-summary-price', $self);
		$actionInput = $('#action', $form);
		$serviceInput = $('#services', $form);
		$servicesOnModal = $('.js-service', $form);
		$servicesQuantityOnModal = $('.js-service-modal-quantity', $form);
		$servicesToAdd = $('.js-services-checkbox');
		$addServicesButton = $('.js-add-services', $form);
	}
	function setEvents() {
		$('.remodal-close', $self).on('click', function () {
			skip();
		});
		$('.js-add-services', $self).on('click', function () {
			addServices();
		});
		$('.js-skip', $self).on('click', function () {
			skip();
		});
		$('.js-service-change-more', $self).on('click', function (event) {
			$(this).closest('.service-item').toggleClass('extended');
			event.stopPropagation();
			event.preventDefault();
		}).on('keyup keypress keydown', function (event) {
			event.stopPropagation();
		});

		$servicesQuantityOnModal.on('change', function () {
			changeQuantity($(this).val(), $(this).data('product'), $(this).data('service'));
			updateServicePrices.run({
				$inputs: $servicesOnModal,
				$box: $summary
			});
		});
		$servicesOnModal.on('click', function () {
			updateExcludedServices.run({
				$input: $(this),
				$inputs: $servicesOnModal
			});
			updateServicePrices.run({
				$inputs: $servicesOnModal,
				$box: $summary
			});
			setButtonStatus();
		});
	}
	let isOneInit = false;
	function init() {

		if (!isOneInit) {
			isOneInit = true;
			broker.on('REFRESH_BASKET_VIEW', function () {
				destroyModalServiceReminder();
			});
			broker.on('REMOVE_ALL_MODALS', function () {
				destroyModalServiceReminder();
			});
		}
	}

	return {
		init,
		open
	};
});
